import axiosInstance from '@/axiosInstance'

export default {
  namespaced: true,
  state: () => ({
    partners: JSON.parse(sessionStorage.getItem('partners') || '[]'),
    isFetched: sessionStorage.getItem('partnersFetched') === 'true'
  }),
  mutations: {
    setPartners(state, partners) {
      state.partners = partners
      state.isFetched = true
      // Cache to sessionStorage
      sessionStorage.setItem('partners', JSON.stringify(partners))
      sessionStorage.setItem('partnersFetched', 'true')
    },
    clearPartners(state) {
      state.partners = []
      state.isFetched = false
      sessionStorage.removeItem('partners')
      sessionStorage.removeItem('partnersFetched')
    }
  },
  actions: {
    async fetchPartners({ commit, state }) {
      if (state.isFetched) return
      try {
        const response = await axiosInstance.get('partners/')
        commit('setPartners', response.data)
      } catch (error) {
        console.error('Error fetching developer:', error)
      }
    },
    async refetchPartners({ commit, dispatch }) {
      commit('clearPartners')
      await dispatch('fetchPartners')
    }
  },
  getters: {
    partners: state => state.partners,
    isFetched: state => state.isFetched
  }
}